export default __webpack_public_path__ + "static/media/Ballroll_00135.732b5290.png";